var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"slider-arrow-round"},[_c('IconSliderArrow',{attrs:{"width":"8","height":"17"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }